// PLT-2165: the "or get a message" form's words, for the floating widget and
// the hosted chat page alike, so the two never say different things.

export type HandoffSendCopy = {
	orGetMessage: string;
	or: string;
	phoneLabel: string;
	send: string;
	sending: string;
	resendIn: (countdown: string) => string;
	consent: (company: string) => string;
	sentTo: (masked: string) => string;
	tapContinue: string;
	didNotGetIt: string;
	invalidPhone: string;
	failed: string;
};

const EN: HandoffSendCopy = {
	orGetMessage: "or get a message",
	or: "or",
	phoneLabel: "Your WhatsApp number",
	send: "Send",
	sending: "Sending…",
	resendIn: (countdown) => `Resend in ${countdown}`,
	consent: (company) => `${company} will message you on WhatsApp about this chat.`,
	sentTo: (masked) => `Sent to ${masked}.`,
	tapContinue: "Tap Continue in WhatsApp.",
	didNotGetIt: "Didn't get it? Open WhatsApp and send us the message instead.",
	invalidPhone: "Check the number and try again.",
	failed: "We couldn't send it. Open WhatsApp instead.",
};

const AR: HandoffSendCopy = {
	orGetMessage: "أو استلم رسالة",
	or: "أو",
	phoneLabel: "رقم واتساب الخاص بك",
	send: "إرسال",
	sending: "جارٍ الإرسال…",
	resendIn: (countdown) => `إعادة الإرسال بعد ${countdown}`,
	consent: (company) => `سترسل لك ${company} رسالة على واتساب بخصوص هذه المحادثة.`,
	sentTo: (masked) => `أُرسلت إلى ${masked}.`,
	tapContinue: "اضغط متابعة في واتساب.",
	didNotGetIt: "لم تصلك؟ افتح واتساب وأرسل لنا الرسالة بدلاً من ذلك.",
	invalidPhone: "تحقق من الرقم وحاول مرة أخرى.",
	failed: "تعذر الإرسال. افتح واتساب بدلاً من ذلك.",
};

export function handoffSendCopy(language: string | null | undefined): HandoffSendCopy {
	return language === "ar" ? AR : EN;
}

/** The phone field's starting value: the org's dialing code, ready to type after. */
export function phoneFieldStart(callingCode: string | null | undefined): string {
	return callingCode ? `+${callingCode} ` : "+";
}
